import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5464_9795)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.5016 11.6102L14.9097 13.6859V16.1585V17.8345L18.5016 15.7588V11.6102ZM8.39421 6.55083L11.986 8.62656L15.5778 6.55083L11.986 4.4751L8.39421 6.55083ZM5.47333 13.6831V15.7588L6.44697 16.3184L9.06517 17.8316V13.6831L5.47333 11.6102V13.6859V13.6831ZM3.52609 16.8809V19.1308L2.55245 18.5683L1.57886 18.0058V11.9985V5.99122L11.986 -0.0161133L22.3932 5.99122V18.0087L17.1881 21.0123L14.9069 22.3286V20.0786L20.4459 16.8809V8.23825L12.9596 12.561C12.9596 13.7602 12.9596 14.9565 12.9596 16.1557V23.4535L11.986 24.016L11.0124 23.4535L6.781 21.0123L5.47333 20.2586V18.0087L11.0124 21.2065V12.5638L3.52609 8.24108V16.8837V16.8809ZM11.986 10.8736L4.49974 6.55083L11.986 2.22808L19.4723 6.55083L11.986 10.8736Z"
        fill="#151718"
      />
    </g>
    <defs>
      <clipPath id="clip0_5464_9795">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(-0.000488281)"
        />
      </clipPath>
    </defs>
  </svg>
)
